import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { InboxAccount } from '../fragments/generated/InboxAccount';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetInboxAccountsQueryVariables = Types.Exact<{
  page: Types.PageInput;
}>;


export type GetInboxAccountsQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id: string, inboxAccounts?: { __typename?: 'InboxAccountConnection', nodes: Array<{ __typename?: 'InboxAccount', id?: string | null, version?: number | null, imageUrl?: string | null, displayName?: string | null }> } | null } | { __typename?: 'IdentifiedUser', id: string } | null };


export const GetInboxAccounts = /*#__PURE__*/ gql`
    query GetInboxAccounts($page: PageInput!) {
  me {
    id
    ... on AuthenticatedUser {
      inboxAccounts(page: $page) {
        nodes {
          ...InboxAccount
        }
      }
    }
  }
}
    ${InboxAccount}` as unknown as DocumentNode<GetInboxAccountsQuery, GetInboxAccountsQueryVariables>;

          

          export const useGetInboxAccountsQuery = (options?:QueryHookOptions<GetInboxAccountsQuery, GetInboxAccountsQueryVariables>) => useQuery(GetInboxAccounts, options);

          

          export type GetInboxAccountsQueryOptions = QueryHookOptions<GetInboxAccountsQuery, GetInboxAccountsQueryVariables>;

          

          export const useGetInboxAccountsLazyQuery = (options?:LazyQueryHookOptions<GetInboxAccountsQuery, GetInboxAccountsQueryVariables>) => useLazyQuery(GetInboxAccounts, options);

          

          export type GetInboxAccountsQueryResult = ReturnType<typeof useGetInboxAccountsQuery>;

          
